export default __webpack_public_path__ + "static/media/photo6.184b5949.jpg";